import gql from 'graphql-tag';

const GET_ALL_SYSTEM_ALERTS = gql`
  query GetAllSystemAlerts($orderBy: SystemAlertOrderByInput) {
    systemAlerts(where: { deleted: false }, orderBy: $orderBy) {
      id
      type
      message
      link
      linkText
      dismissible
      active
      startDate
      endDate
      priority
      createdBy {
        id
        username
        name
      }
      createdAt
      updatedBy {
        id
        username
        name
      }
      updatedAt
    }
  }
`;

export default GET_ALL_SYSTEM_ALERTS;
